export default "__VITE_ASSET__db6bb71d__"